export default __webpack_public_path__ + "static/media/profile-bg.50c00f2e.jpeg";